import { mapValues } from 'lodash'

import HttpClient from '@/common/lib/http-client'
import { ISchedule, Schedule } from '@/common/models/data/dashboard/schedule/schedule'

import { schedule as Api } from '@/app/api'

class ScheduleRepository {
    async all (): Promise<Record<string, Array<Schedule>>> {
        const response = await HttpClient.getJson<Record<string, Array<ISchedule>>>(Api.index)

        return mapValues(response, arr => arr.map(schedule => new Schedule(schedule)))
    }
}

export default new ScheduleRepository()
